function buildDefaultLegendSpec(settings) {
  return settings.layers
    .filter((layer) => layer.id !== "default")
    .map((layer, idx) => {
      return {
        name: layer.name || `Calque ${idx}`,
        layer_ids: [layer.id],
        visible_by_default: true,
        // by default: never check for in area or at zoom level
        when_in_area: false,
        when_at_zoom_level: false,
      };
    });
}

function uniformizeSpec(spec, settings) {
  return spec.map((spec_item) => {
    // add layers
    const layers = settings.layers.filter((layer) =>
      spec_item.layer_ids.includes(layer.id),
    );

    // set default param: false (no check) for area and zoom_level
    const when_in_area =
      spec_item.when_in_area === "undefined" ? false : spec_item.when_in_area;
    const when_at_zoom_level =
      spec_item.when_at_zoom_level === "undefined"
        ? false
        : spec_item.when_at_zoom_level;

    return { ...spec_item, layers, when_in_area, when_at_zoom_level };
  });
}

function buildLegend(chart, container, legend_spec) {
  let settings = chart._impl.settings;

  if (legend_spec.length === 0) {
    legend_spec = buildDefaultLegendSpec(settings);
  }

  // dont build a legend wrapper if no layers
  if (legend_spec.length === 0) {
    return;
  }

  legend_spec = uniformizeSpec(legend_spec, settings);

  const items = legend_spec.map((legend_spec_item, idx) => {
    const { name, layer_ids, visible_by_default } = legend_spec_item;
    // <input id="v3" type="radio" name="nodeType" value="hexagon"/> Hexagon</label><br/>')
    var legend_item = document.createElement("input");
    legend_item.classList.add("legend-item");

    [
      ["type", "checkbox"],
      ["name", "legend-item-" + idx],
      ["checked", visible_by_default === false ? null : "true"],
      ["value", idx],
    ].forEach(([k, v]) => {
      // for checked: don't set anything (unchecked by default)
      if (v != null) {
        legend_item.setAttribute(k, v);
      }
    });

    // create legend
    var legend_label = document.createElement("span");
    legend_label.classList.add("legend-label");
    legend_label.textContent = name;

    // create wrapper and add childs
    var wrapper = document.createElement("div");
    wrapper.classList.add("legend-wrapper");

    wrapper.appendChild(legend_item);
    wrapper.appendChild(legend_label);

    wrapper.addEventListener("click", (e) => {
      // check was already done
      if (e.target !== legend_item) {
        legend_item.checked = !legend_item.checked;
      }

      const layer_update = layer_ids.map((layer_id) => {
        return { id: layer_id, enabled: legend_item.checked };
      });

      chart.updateSettings({ layers: layer_update });

      return false;
    });

    return { ...legend_spec_item, wrapper: wrapper };
  });

  // on start: hide layer
  hide_layer_from_spec(chart, legend_spec);

  const root = document.createElement("div");
  root.classList.add("legend-root");
  root.classList.add("leaflet-container");

  items.forEach((legend_spec_item) => {
    const wrapper = root.appendChild(legend_spec_item.wrapper);
    legend_spec_item.wrapper = wrapper;
  });

  chart.on("chartUpdate", (e) => {
    toggleLegend(items, chart);
  });

  container.appendChild(root);
}

function hide_layer_from_spec(chart, legend_spec) {
  const list_of_list_of_layer_ids = legend_spec
    .filter(({ visible_by_default }) => visible_by_default === false)
    .map(({ layer_ids }) => layer_ids);

  const layer_ids = [].concat.apply([], list_of_list_of_layer_ids);

  if (layer_ids.length > 0) {
    chart.updateSettings({
      layers: layer_ids.map((layer_id) => {
        return { id: layer_id, enabled: false };
      }),
    });
  }
}

// dependign on the when_in_area/when_at_zoom_level
function toggleLegend(items, chart) {
  items.forEach((legend_spec_item) => {
    let { when_in_area, when_at_zoom_level } = legend_spec_item;
    // nothing to check
    if (!when_in_area && !when_at_zoom_level) {
      return;
    }

    var visible = false;

    const visible_layers = chart._impl.renderer.layers.filter((x) => {
      const layer = x.layer;

      if (!!layer && layer.nodes) {
        return layer.nodes().length > 0 || layer.links().length > 0;
      }
      return false;
    });

    // console.log(visible_layers.map((x) => x.layerSettings.id));
    if (when_in_area && when_at_zoom_level) {
      visible =
        check_when_at_zoom_level(legend_spec_item, chart) &&
        check_when_in_area(legend_spec_item, visible_layers);
    } else if (when_at_zoom_level) {
      visible = check_when_at_zoom_level(legend_spec_item, chart);
    } else {
      visible = check_when_in_area(legend_spec_item, visible_layers);
    }

    legend_spec_item.wrapper.style = "display: " + (visible ? "block" : "none");
  });
}

function check_when_at_zoom_level(legend_spec_item, chart) {
  const zoomlevel = chart.zoomLevel();

  return legend_spec_item.layers.some((layer) => {
    const respect_max_zoom = layer.maxZoom ? zoomlevel <= layer.maxZoom : true;
    const respect_min_zoom = layer.minZoom ? zoomlevel >= layer.minZoom : true;
    return respect_max_zoom && respect_min_zoom;
  });
}

function check_when_in_area(legend_spec_item, visible_layers) {
  return legend_spec_item.layers.some((layer) => {
    return visible_layers.some(
      (visible_layer) => visible_layer.layerSettings.id === layer.id,
    );
  });
}

export { buildLegend };
